import { Theme } from './theme';

export function getTableStyles(theme: Theme) {
	const css = {
		table_css: {
			fontFamily: theme.table.fontFamily,
			width: '100%',
			BorderCollapse: 'collapse'
		},
		tableContainer_css: {
			...theme.table.container
		},
		tableHeader_css: {
			...theme.table.header
		},
		tableHeaderCell_css: {
			...theme.table.cell,
			...theme.table.header,
			textAlign: 'left' as const
		},
		tableRow_css: {
			...theme.table.row
		},
		tableCell_css: {
			...theme.table.cell
		}
	};
	return css;
}
